module.exports = __webpack_public_path__ + "img/jgoushou.49cf0ff4.gif";